var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHearts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 64",
    style: {
      enableBackground: "new 0 0 140 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#707070;fill-opacity:0.5;}\n\t.st1{fill:#707070;fill-opacity:0.5;}\n\t.st2{fill:#CCCCCC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,57L7.2,40.7c-5.8-4-7.6-12.1-3.8-18.1c3.7-6,11.5-7.6,17.3-3.7l4.5,3.8l2.6-5.3c3.7-6,11.5-7.6,17.3-3.7 c5.8,4,7.6,12.1,3.8,18.1L34.5,56.1C33.6,57.6,31.7,58,30.3,57L30.3,57z"
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "fill-opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "1.4s",
    fill: "remove",
    repeatCount: "indefinite",
    restart: "always",
    values: "0.5;1;0.5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.5,56.1L91.1,31.8c-3.7-6-2-14.1,3.8-18.1c5.8-4,13.6-2.3,17.3,3.7l2.6,5.3l4.5-3.8 c5.8-4,13.6-2.3,17.3,3.7c3.7,6,2,14.1-3.8,18.1L109.7,57C108.3,58,106.4,57.6,105.5,56.1z"
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "fill-opacity",
    begin: "0.7s",
    calcMode: "linear",
    dur: "1.4s",
    fill: "remove",
    repeatCount: "indefinite",
    restart: "always",
    values: "0.5;1;0.5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.4,57.8l-23-25c-5.9-6.1-5.9-16.1,0-22.2c5.9-6.1,15.4-6.1,21.2,0l4.4,5.6l4.4-5.6c5.9-6.1,15.4-6.1,21.2,0 c5.9,6.1,5.9,16.1,0,22.2l-23,25C71.2,59.4,68.8,59.4,67.4,57.8L67.4,57.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.23c4a4201bbd334120379b83eeba1674.svg";
export { ForwardRef as ReactComponent };